import SampleData from "../../sampledata.json"
import ReactPhotoGallery, { PhotoProps } from "react-photo-gallery"
import { useCallback } from 'react'
import Img from "../Img"

interface imageRenderProps {
    index: number,
    left: number,
    top: number,
    key: string | number,
    photo: PhotoProps
}

const Gallery = (): JSX.Element => {
    const imageRenderer: any = useCallback(
        ({ index, left, top, key, photo }: imageRenderProps) => {
            return (
                <Img
                    key={key}
                    src={photo.src}
                    alt={photo.alt || ''}
                    height={photo.height}
                    width={photo.width}
                    style={{
                        position: "absolute",
                        top,
                        left,
                    }}
                    className="m-2 cursor-pointer"
                />
            )
        },
        []
    );
    return (
        <div className="flex flex-col gap-1">
            <h3>Gallery</h3>
            <ReactPhotoGallery photos={SampleData.gallery} direction={"column"} renderImage={imageRenderer} />

        </div>
    )
}






export default Gallery